import type { UseFormReturn } from 'react-hook-form';

import { FormField, FormInput } from '@/_components';
import { FormCurrencyInput, FormPercentageInput } from '@/_containers';

import { CommissionEarningModelInput } from './components/commission-earning-model';
import type { CommissionPlansFormSchema } from './schemas';

export function FormFields({
  form,
  isEditable = true,
  autoFocus = false,
}: {
  form: UseFormReturn<CommissionPlansFormSchema>;
  isEditable?: boolean;
  autoFocus?: boolean;
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="name"
        render={({ field }) => (
          <FormInput
            formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
            label="Name (required)"
            {...field}
            disabled={!isEditable}
            autoFocus={autoFocus}
          />
        )}
      />

      <CommissionEarningModelInput isEditable={isEditable} className="col-span-12 sm:col-span-6 lg:col-span-4" />

      <FormCurrencyInput
        isEditable={isEditable}
        name="base_quota_amount"
        formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
        label="Base Quota Amount"
      />

      <FormPercentageInput
        isEditable={isEditable}
        name="default_one_time_rate"
        label="Default One-Time Rate"
        formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
      />

      <FormPercentageInput
        isEditable={isEditable}
        name="default_recurring_rate"
        label="Default Recurring Rate"
        formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4 2xl:col-span-4"
      />

      <FormCurrencyInput
        isEditable={isEditable}
        name="bonus_amount"
        formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
        label="Bonus Amount"
      />

      <FormCurrencyInput
        isEditable={isEditable}
        name="bonus_threshold"
        formItemClassName="col-span-12 sm:col-span-6 lg:col-span-4"
        label="Bonus Threshold"
      />
    </>
  );
}
